var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',_vm._b({attrs:{"src":_vm.source}},'b-img',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }